import axios from 'axios';

const API_URL = 'https://admin-gg-be.visamonde.com'; // Assure-toi que c'est la bonne URL

export const getDemandes = async (id_societe) => {
  const response = await axios.get(`${API_URL}/demandes/${id_societe}`);
  return response.data;
};
